<ng-container *ngIf="{ legalDocumentStorage: legalDocumentsBloc.legalDocumentStorage$ | async } as observables">
  <button (click)="clickFullPolicyLink()">{{ policyText }}</button>
  <kui-modal
    *ngIf="showFullPolicy && policyType === legalDocumentType.PRIVACY"
    [isOpen]="showFullPolicy && policyType === legalDocumentType.PRIVACY"
    [html]="observables.legalDocumentStorage?.privacy?.data?.contentAsParsedHtml"
    type="legal"
    (isOpenChange)="isFullPolicyOpen($event)"></kui-modal>

  <kui-modal
    *ngIf="showFullPolicy && policyType === legalDocumentType.EULA"
    [isOpen]="showFullPolicy && policyType === legalDocumentType.EULA"
    [html]="observables.legalDocumentStorage?.eula?.data?.contentAsParsedHtml"
    type="legal"
    (isOpenChange)="isFullPolicyOpen($event)"></kui-modal>
</ng-container>
